import React from 'react';

import { Urls } from 'js/src/client';
import { PrimaryButton, TertiaryButton } from 'js/src/components/common/ui/Button';
import Modal from 'js/src/components/common/ui/modal';
import type { PlanSwitchErrorInfo } from 'js/src/components/pricing/types';

type Props = {
    showing?: boolean;
    errorInfo: PlanSwitchErrorInfo | null;
    onModalClose: (visibilityFlag: boolean) => void;
};

const PlanSwitchErrorHandlerModal = React.memo(function PlanSwitchErrorHandlerModal({
    showing = false,
    errorInfo,
    onModalClose,
}: Props) {
    let userMessage = '';
    if (errorInfo) {
        const errorProp = errorInfo.feature;
        switch (errorProp) {
            case 'can_invite_team_member':
                userMessage = `The ${errorInfo.targetPlan.display_name} plan does not support team members. 
                    Please remove all team members before downgrading.`;
                break;
            default:
                userMessage = 'Something went wrong. Please try again.';
                break;
        }
    }

    const handleModalClose = () => {
        onModalClose(false);
    };

    const handleTeamManagementNavigation = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        onModalClose(false);
        window.location.href = Urls.TEAM_MANAGEMENT;
    };

    return (
        <Modal showing={showing} title="Switch plan" onHidden={handleModalClose}>
            <p>{userMessage}</p>
            <div className="modal-button-footer">
                <TertiaryButton onClick={handleModalClose} text="Cancel" />
                <PrimaryButton
                    onClick={handleTeamManagementNavigation}
                    text="Manage team members"
                />
            </div>
        </Modal>
    );
});

export default PlanSwitchErrorHandlerModal;
